import { RouteConfig } from "vue-router";

export const RCandidateTemplateProfile: RouteConfig = {
  path: "profile/:tabTypeId(\\d+)",
  component: () =>
    import(
      /* webpackChunkName: "candidate-template-profile" */
      "./VTemplateProfile.vue"
    ),
  meta: {
    label: "Profile",
    tabName: "profile",
  },
};

export const RExpertTemplateProfile: RouteConfig = {
  path: "profile/:tabTypeId(\\d+)",
  component: () =>
    import(
      /* webpackChunkName: "expert-template-profile" */
      "./VTemplateProfile.vue"
    ),
  meta: {
    label: "Profile",
    tabName: "profile",
  },
};
